module.exports = __webpack_public_path__ + "static/img/partner_XV.bc6c88d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XV.png
// module id = eLFX
// module chunks = 9